import { TFormErrors, TFormValues } from '../types';

/** Валидирует значения инпутов и возвращаем для них ошибки, если валидация не пройдена */
export const validatePhoneFormInputs = (values: TFormValues) => {
  const errors: TFormErrors = {};

  if (!values.question) {
    errors.question = 'Укажите вопрос';
  } else {
    errors.question = undefined;
  }

  if (!values.phone) {
    errors.phone = 'Укажите ваш телефона';
  } else if (!/\d{10}/.test(values.phone)) {
    errors.phone = 'Номер указан не полностью';
  } else {
    errors.phone = undefined;
  }

  return errors;
};

export const validateEmailFormInputs = (values: TFormValues) => {
  const errors: TFormErrors = {};

  if (!values.question) {
    errors.question = 'Укажите вопрос';
  } else {
    errors.question = undefined;
  }

  if (!values.email) {
    errors.email = 'Укажите ваш email';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = 'Указан неверный формат email';
  } else {
    errors.email = undefined;
  }

  return errors;
};
